<script>
  export let item = {
    connections: [false, false, false, false], // top left right bottom
    show: false 
  }

  export let tileWidth = 100
  export let tileHeight = 100
  export let colIndex = 0
  export let rowIndex = 0

</script>

{#if item.show}
  <circle cx={tileWidth * (colIndex + 0.5)} cy={tileHeight * (rowIndex + 0.5)} r={tileHeight * 0.5} />
  {#if item.connections[0]}
    <rect x={tileWidth * (colIndex + 0)} y={tileHeight * (rowIndex + 0)} width={tileWidth * 1} height={tileHeight * 0.5} />
  {/if}
  {#if item.connections[1]}
    <rect x={tileWidth * (colIndex + 0)} y={tileHeight * (rowIndex + 0)} width={tileWidth * 0.5} height={tileHeight * 1} />
  {/if}
  {#if item.connections[2]}
    <rect x={tileWidth * (colIndex + 0.5)} y={tileHeight * (rowIndex + 0)} width={tileWidth * 0.5} height={tileHeight * 1} />
  {/if}
  {#if item.connections[3]}
    <rect x={tileWidth * (colIndex + 0)} y={tileHeight * (rowIndex + 0.5)} width={tileWidth * 1} height={tileHeight * 0.5} />
  {/if}
{/if}


<style>
  rect, circle {
    
  }
</style>